import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import UserView from "./pages/UserView";
import Profile from "./pages/Profile";
import Analytics from "./pages/Analytics";
import SubCategory from "./pages/SubCategory";

import AiServices from "./pages/AiServices";
import CategoryManagement from "./pages/CategoryManagement";
import BusinessNameManagement from "./pages/BusinessNameManagement";
import Notifications from "./pages/Notifications";
import OfferBannerManagement from "./pages/OfferBannerManagement";
import LanguageManagement from "./pages/LanguageManagement";
import Reviews from "./pages/Reviews";
import Settings from "./pages/Settings";
import Subscriptions from "./pages/Subscriptions";
import { ThemeProvider } from "./contexts/ThemeContext";

import BusinessManagement from "./pages/BusinessManagement";
import DailyContent from "./pages/DailyContent";
import PoliticsNameManagement from "./pages/PoliticsNameManagement";
import PoliticsManagement from "./pages/PoliticsManagement";
import FestivalCalendar from "./pages/FestivalCalendar";
import DailyDarshan from "./pages/DailyDarshan";
import UserGroups from "./pages/UserGroups";
import MusicManagement from "./pages/MusicManagement";
import TransactionHistory from "./pages/TransactionHistory";
import SplashPosterManagement from "./pages/SplashPosterManagement";

// Route guard for authenticated admin routes:
// Redirects to / (Login) if token is missing (e.g. Incognito or logged out)
const ProtectedLayout = () => {
  const token = localStorage.getItem("token");
  if (!token) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
};

// Route guard for login route:
// Redirects to /dashboard if already logged in
const PublicLayout = () => {
  const token = localStorage.getItem("token");
  if (token) {
    return <Navigate to="/dashboard" replace />;
  }
  return <Outlet />;
};

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Route (Login) */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Login />} />
          </Route>

          {/* Protected Routes (Require Authentication) */}
          <Route element={<ProtectedLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/users" element={<Users />} />
            <Route path="/user-groups" element={<UserGroups />} />
            <Route path="/users/:id" element={<UserView />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/subcategory" element={<SubCategory />} />
            <Route path="/sub-category" element={<SubCategory />} />
            <Route path="/categories" element={<CategoryManagement />} />
            <Route path="/business-categories" element={<BusinessNameManagement />} />
            <Route path="/business" element={<BusinessManagement />} />
            <Route path="/politics-categories" element={<PoliticsNameManagement />} />
            <Route path="/politics" element={<PoliticsManagement />} />

            <Route path="/ai-services" element={<AiServices />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/offer-banners" element={<OfferBannerManagement />} />
            <Route path="/banner-management" element={<OfferBannerManagement />} />
            <Route path="/splash-poster" element={<SplashPosterManagement />} />
            <Route path="/splash-screen" element={<SplashPosterManagement />} />
            <Route path="/languages" element={<LanguageManagement />} />
            <Route path="/reviews-feedback" element={<Reviews />} />
            <Route path="/subscriptions" element={<Subscriptions />} />
            <Route path="/transactions" element={<TransactionHistory />} />
            <Route path="/transaction-history" element={<TransactionHistory />} />
            <Route path="/daily-content" element={<DailyContent />} />
            <Route path="/festival-calendar" element={<FestivalCalendar />} />
            <Route path="/daily-darshan" element={<DailyDarshan />} />
            <Route path="/music" element={<MusicManagement />} />
            <Route path="/music-management" element={<MusicManagement />} />

            <Route path="/settings" element={<Settings />} />
          </Route>

          {/* Catch-all: Redirect unknown routes */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
